"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalStorageAssignmentCache = void 0;
const js_client_sdk_common_1 = require("@eppo/js-client-sdk-common");
const configuration_factory_1 = require("../configuration-factory");
class LocalStorageAssignmentCache extends js_client_sdk_common_1.AbstractAssignmentCache {
    constructor(storageKeySuffix) {
        super(new LocalStorageAssignmentShim(storageKeySuffix));
    }
    setEntries(entries) {
        entries.forEach(([key, value]) => {
            if (key && value) {
                this.delegate.set(key, value);
            }
        });
    }
    getEntries() {
        return Promise.resolve(Array.from(this.entries()));
    }
}
exports.LocalStorageAssignmentCache = LocalStorageAssignmentCache;
// noinspection JSUnusedGlobalSymbols (methods are used by common repository)
class LocalStorageAssignmentShim {
    constructor(storageKeySuffix) {
        if (!(0, configuration_factory_1.hasWindowLocalStorage)()) {
            throw new Error('LocalStorage is not available');
        }
        const keySuffix = storageKeySuffix ? `-${storageKeySuffix}` : '';
        this.localStorageKey = `eppo-assignment${keySuffix}`;
    }
    clear() {
        this.getCache().clear();
    }
    delete(key) {
        return this.getCache().delete(key);
    }
    forEach(callbackfn, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    thisArg) {
        this.getCache().forEach(callbackfn, thisArg);
    }
    entries() {
        return this.getCache().entries();
    }
    keys() {
        return this.getCache().keys();
    }
    values() {
        return this.getCache().values();
    }
    [Symbol.iterator]() {
        return this.getCache()[Symbol.iterator]();
    }
    has(key) {
        return this.getCache().has(key);
    }
    get(key) {
        var _a;
        return (_a = this.getCache().get(key)) !== null && _a !== void 0 ? _a : undefined;
    }
    set(key, value) {
        return this.setCache(this.getCache().set(key, value));
    }
    getCache() {
        const cache = window.localStorage.getItem(this.localStorageKey);
        return cache ? new Map(JSON.parse(cache)) : new Map();
    }
    setCache(cache) {
        window.localStorage.setItem(this.localStorageKey, JSON.stringify(Array.from(cache.entries())));
        return this;
    }
}
Symbol.toStringTag;
//# sourceMappingURL=local-storage-assignment-cache.js.map